import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import * as rk from '../../localization/resourceKeys';
import { DeleteMyInfoIcon, DoNotSellIcon, AccessMyInfoIcon, CorrectMyInfoIcon } from "../Icons/icons"
import * as T from "../../redux/constants";
import './requestConfirmation.css';
import { SkipNavLink, SkipNavContent } from "@reach/skip-nav";
import "@reach/skip-nav/styles.css";
import BottomLine from "../Footer/BottomLine";
import i18n from "../../i18n";
import { setRequestForm } from "../../redux/requestForm/requestFormAction";
import PropTypes from "prop-types";
import { specialPolicyStates } from "../../utils/statesUS";

class GetFormComplete extends Component {
  constructor(props){
    super(props);
    if (!props?.selectedRequest) {
      window.location.replace("/");
    }
    const currentStateResidence = props.stateSelector?.currentStateResidence;
    const selectedRequest = props.selectedRequest;
    const isKnowMyPersonalInfoQuebec = currentStateResidence === "QC" && selectedRequest === i18n.t(rk.REQUEST_SELECTOR.ACCESS_INFO);
    this.isKnowMyPersonalInfoQuebec = isKnowMyPersonalInfoQuebec;
  }
  
    componentDidMount() {
      const _this = this;
      this.props.clearAll();
      window.addEventListener("popstate", e => {
        _this.props.history.push('/')

      });
      if (this.isKnowMyPersonalInfoQuebec) {
        setTimeout(() => {
          this.props.history.push('/');
        }, 6000);
      }
    }
    anotherRequest = (e) => {
        this.props.history.push('verificationForm', {
          isRequestConfirmation: true,
        });
        const payload = {
          ...this.props.requestForm,
          selectedFlow: "check",
        };
        this.props.setRequestForm(payload);
    }

    isProtectionServices = () => {
      return this.props?.stateSelector?.brandAffiliation === i18n.t(rk.BRANDS_OPTION_VWD_APP_DER);
    }

    isDeleteMyInfoSpecialPolicyState = () => {
      const { currentStateResidence } = this.props?.stateSelector || {};
      const { selectedRequest } = this.props;
      const deleteInfoRequest = i18n.t(rk.REQUEST_SELECTOR.DELETE_INFO);

      if (
        specialPolicyStates.includes(currentStateResidence) &&
        selectedRequest === deleteInfoRequest
      ) {
        return true;
      }
      return false;
    }

    isCorrectMyInfoNE = () => {
      const currentStateResidence = this.props?.stateSelector?.currentStateResidence;
      if (currentStateResidence === 'NE' && this.props.selectedRequest === i18n.t(rk.REQUEST_SELECTOR.CORRECT_INFO)) {
        return true;
      } else return false;
    }

    showButton = () => {
      if (this.isKnowMyPersonalInfoQuebec) {
        return false;
      }
      if (
        (
        this.isDeleteMyInfoSpecialPolicyState() ||
        this.props.location.state.isDataCorrectionFormComplete || 
        this.isCorrectMyInfoNE()
      ) && this.isProtectionServices()
      ) {
        return false;
      }
      return true
    }
   
    render() {
        const { t } = this.props;
        const isTier1FormComplete =
          this.props.location.state ||
          this.props.info.reportType === "Categories Report"
            ? this.props.location.state.isTier1FormComplete
            : "";
        const isTier2FormComplete =
          this.props.location.state ||
          this.props.info.reportType === "Specific Pieces Report"
            ? this.props.location.state.isTier2FormComplete
            : "";
        const isDeleteFormComplete = this.props.location.state ? this.props.location.state.isDeleteFormComplete : "";
        const isDNSFormComplete = this.props.location.state ? this.props.location.state.isDNSFormComplete : "";
        const isDNUFormComplete = this.props.location.state ? this.props.location.state.isDNUFormComplete : "";
        const isDataCorrectionFormComplete = this.props.location.state ? this.props.location.state.isDataCorrectionFormComplete : "";
        const isLimitDataFormComplete = this.props.location.state ? this.props.location.state.isLimitDataFormComplete : "";

        return (
          <div className="request-confirmation-container">
            <SkipNavLink />
            {isTier1FormComplete && (
              <>
                <div className="u-m-none">
                  <div className="u-1/1 u-text-center">
                    <AccessMyInfoIcon />
                  </div>
                </div>
                <div className="u-m-none u-mb">
                  <div className="u-1/1 u-text-center request-confirmation-text">
                    {t(rk.KNOW_MY_INFO_FORM.THANK_YOU)}
                  </div>
                </div>
              </>
            )}
            {isTier2FormComplete && (
              <>
                <div className="u-m-none">
                  <div className="u-1/1 u-text-center">
                    <AccessMyInfoIcon />
                  </div>
                </div>
                <div className="u-m-none u-mb">
                  <div className="u-1/1 u-text-center request-confirmation-text">
                    {t(rk.KNOW_MY_INFO_FORM.THANK_YOU)}
                  </div>
                </div>
              </>
            )}
            {isDNSFormComplete && (
              <>
                <div className="u-m-none">
                  <div className="u-1/1 u-text-center">
                    <DoNotSellIcon />
                  </div>
                </div>
                <div className="u-m-none u-mb">
                  <div className="u-1/1 u-text-center request-confirmation-text">
                    {t(rk.DNS_FORM.THANK_YOU)}
                  </div>
                </div>
              </>
            )}
            {isDNUFormComplete && (
              <>
                <div className="u-m-none">
                  <div className="u-1/1 u-text-center">
                    <DoNotSellIcon />
                  </div>
                </div>
                <div className="u-m-none u-mb">
                  <div className="u-1/1 u-text-center request-confirmation-text">
                    {t(rk.DNU_FORM.THANK_YOU)}
                  </div>
                </div>
              </>
            )}
            {isDeleteFormComplete && (
              <>
                <div className="u-m-none">
                  <div className="u-1/1 u-text-center">
                    <DeleteMyInfoIcon />
                  </div>
                </div>
                <div className="u-m-none u-mb">
                  <div className="u-1/1 u-text-center request-confirmation-text">
                    {t(rk.DELETE_FORM.THANK_YOU)}
                  </div>
                </div>
              </>
            )}
            {isDataCorrectionFormComplete && (
              <>
                <div className="u-m-none">
                  <div className="u-1/1 u-text-center">
                    <CorrectMyInfoIcon />
                  </div>
                </div>
                <div className="u-m-none u-mb">
                  <div className="u-1/1 u-text-center request-confirmation-text">
                    {t(rk.DATA_CORRECTION_FORM.THANK_YOU)}
                  </div>
                </div>
              </>
            )}
            {isLimitDataFormComplete && (
              <>
                <div className="u-m-none">
                  <div className="u-1/1 u-text-center">
                    <DoNotSellIcon />
                  </div>
                </div>
                <div className="u-m-none u-mb">
                  <div className="u-1/1 u-text-center request-confirmation-text">
                    {t(rk.LIMIT_DATA_FORM.THANK_YOU)}
                  </div>
                </div>
              </>
            )}
            {this.showButton() && (
              <div className="u-m-none">
                <div className="u-1/1 center-div portal-home-button">
                  <SkipNavContent />
                  <button
                    className="c-btn"
                    onClick={(e) => this.anotherRequest(e)}
                    disabled={false}
                    data-testid="viewRequestButton"
                  >
                    <span className="c-btn__text">
                      {t(rk.BUTTON.VIEW_REQUEST_STATUS)}
                    </span>
                  </button>
                </div>
              </div>
            )}
            <div className="request-footer-wrapper">
              <div
                id="request-footer-content"
                className="request-footer-content-2"
              >
                <BottomLine />
              </div>
            </div>
          </div>
        );
    }
}

GetFormComplete.propTypes = {
  info: {
    reportType: PropTypes.string,
    isReportComplete: PropTypes.bool,
    isReportError: PropTypes.bool,
  },
  selectedRequest: PropTypes.string,
  stateSelector: {
    currentStateResidence: PropTypes.string,
    brandAffiliation: PropTypes.string,
  },
  history: PropTypes.object,
  location: {
    state: {
      isTier1FormComplete: PropTypes.bool,
      isTier2FormComplete: PropTypes.bool,
      isDeleteFormComplete: PropTypes.bool,
      isDNSFormComplete: PropTypes.bool,
      isDNUFormComplete: PropTypes.bool,
      isDataCorrectionFormComplete: PropTypes.bool,
      isLimitDataFormComplete: PropTypes.bool,
    },
  },
  requestForm: PropTypes.object,
  setRequestForm: PropTypes.func,
  t: PropTypes.func,
};

const mapStateToProps = (state) => ({
  info: state.info,
  selectedRequest: state.requestSelector.selectedRequest,
  stateSelector: state.stateSelector,
  requestForm: state.requestForm,
});

const mapDispatchToProps = dispatch => ({
  setRequestForm: (payload) => dispatch(setRequestForm(payload)),
  clearAll: () => dispatch({ type: T.RIGHT_TO_CORRECT.CLEAR_ALL }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(GetFormComplete));
